var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  x: 1,
  y: 0.5,
  fill: "currentColor",
  rx: 3.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#77838F",
  d: "M20.333 18.167H6v-13A.167.167 0 0 0 5.833 5H4.667a.167.167 0 0 0-.167.167V19.5c0 .092.075.167.167.167h15.666a.167.167 0 0 0 .167-.167v-1.167a.167.167 0 0 0-.167-.166M8.204 14.952a.167.167 0 0 0 .236 0l2.88-2.867 2.66 2.675c.064.065.17.065.235 0l5.737-5.735a.167.167 0 0 0 0-.235l-.825-.825a.167.167 0 0 0-.235 0l-4.792 4.79-2.654-2.672a.167.167 0 0 0-.236 0L7.381 13.89a.167.167 0 0 0 0 .235z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  x: 1,
  y: 0.5,
  stroke: "#D2D6DA",
  rx: 3.5
})));
export default SvgChartIcon;